import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addErrorMessage, removeErrorMessage } from '../../redux/slices/appStateSlice';

const useErrorState = function (uid, name, fields, onError) {
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const customSetError = useCallback(
    newError => {
      let errorObject = null;
      if (newError) {
        if (typeof newError === 'function') {
          errorObject = newError;
        } else {
          errorObject = prepareErrorObject(uid, name, newError, fields);
        }
      }
      setError(errorObject);

      if (typeof onError === 'function') {
        onError(errorObject);
      } else {
        if (errorObject) {
          dispatch(addErrorMessage(errorObject));
        } else {
          dispatch(removeErrorMessage(uid));
        }
      }
    },
    [uid, name, dispatch]
  );

  return [error, customSetError];
};

const prepareErrorObject = function (uid, name, newError, fields) {
  const inline = fields?.inlineError?.value || false;

  let message, type;
  if (typeof newError === 'object') {
    message = newError.message;
    type = newError.type;
  } else if (fields?.[newError]?.value !== undefined && fields?.[newError]?.value !== null) {
    message = fields?.[newError]?.value;
    type = newError;
  } else {
    message = newError;
    type = 'custom';
  }

  return {
    uid,
    message,
    type,
    inline,
    name: name || 'unknown',
  };
};

export default useErrorState;
